import { type AristotleExperiments, ExperimentType } from '@shared/types/experiments'
import { getObjectFromEntries } from '@/features/shared/utils/types'

export const defaultExperiments: AristotleExperiments = getObjectFromEntries(
  Object.values(ExperimentType).map((type) => [type, { value: undefined }]),
)
